import axios from 'axios'
import LocalStorage from '@/utils/LocalStorage'
import Constant from '@/configs/constant'
import store from '@/store'
import i18n from '@/plugins/i18n'
// import google from '@/plugins/google'

// create an axios instance
const http = axios.create({
})
export default http

const timeout = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

http.interceptors.request.use(
  async config => {
    // Do something before request is sent
    const token = LocalStorage.getToken()
    const isJsonFile = config.url.indexOf('.json') !== -1
    const isPriceUrl = config.url === Constant.PRICE_LINK
    if (token && !isJsonFile && !isPriceUrl) {
      config.headers.authorization = 'Bearer ' + token
    }
    // if (config.method.toUpperCase() === 'POST') {
    //   const urlSplit = config.url.split('/')
    //   const action = urlSplit[urlSplit.length - 1].replace(/-/g, '')
    //   let reCaptcha
    //   if (action.indexOf('?' !== -1)) {
    //     const newAction = action.split('?')[0]
    //     reCaptcha = await google.getCaptcha(newAction)
    //   } else {
    //     reCaptcha = await google.getCaptcha(action)
    //   }
    //   reCaptcha && (config.data.reCaptcha = reCaptcha)
    // }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

http.interceptors.response.use(
  async response => {
    var data = response.data
    const method = response.config.method
    if (method !== 'get') {
      await timeout(Constant.DELAY_TIME)
    }
    if (data.message) {
      const storeAction = data.status ? 'showSuccessMsg' : 'showErrorMsg'
      store.dispatch(storeAction, i18n.t(data.message))
    }
    if (data.result !== null && data.result !== undefined) return data.result
    else return data
  },
  async error => {
    // Refresh token
    const rs = error.response
    if (rs && rs.status === Constant.UNAUTHORIZED_CODE) {
      store.dispatch('logout')
    } else if (rs && rs.status === Constant.INVALID_TOKEN) {
      store.dispatch('logout')
    }
    return Promise.reject(error)
  }
)
